export default __webpack_public_path__ + "static/media/wikima.c6ccc011.webp";